// ABOUTME: Collapsed recent-activity feed of background jobs (shared by Interviews + Analysis pages)

import { Job } from '@/api/ingestion'

export function ActivityPanel({ jobs }: { jobs: Job[] | undefined }) {
  if (!jobs || jobs.length === 0) return null
  const running = jobs.filter((j) => j.status === 'queued' || j.status === 'running').length
  const done = jobs.length - running
  return (
    <details className="rounded-lg border border-gray-200">
      <summary className="cursor-pointer px-4 py-2 text-sm text-gray-600 select-none">
        Recent activity ({running} running, {done} done)
      </summary>
      <ul className="divide-y divide-gray-100 px-4 pb-2">
        {jobs.slice(0, 15).map((j) => (
          <li key={j.job_id} className="py-2 text-sm flex items-baseline gap-2 flex-wrap">
            <span className="font-medium text-gray-800">{j.kind}</span>
            <span className="text-gray-600 truncate">{j.target_label ?? j.target_ref ?? '—'}</span>
            <span className={`text-xs px-1.5 py-0.5 rounded-full ${
              j.status === 'completed' ? 'bg-green-100 text-green-700'
              : j.status === 'failed' ? 'bg-red-100 text-red-700'
              : 'bg-blue-100 text-blue-700'
            }`}>{j.status}</span>
            <span className="text-xs text-gray-400">{new Date(j.created_at).toLocaleString()}</span>
            {j.error && <span className="basis-full text-xs text-red-600 whitespace-pre-wrap">{j.error}</span>}
          </li>
        ))}
      </ul>
    </details>
  )
}
